import { useAuthentication } from '@src/authentication/useAuthentication';
import { LoadingPage } from '@src/common/components/LoadingPage';
import { Navigation } from '@src/routing/Navigation';
import type { PropsWithChildren } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export function NoAuth({ children }: PropsWithChildren) {
  const location = useLocation();
  const { user, isLoading } = useAuthentication();

  if (isLoading) {
    return <LoadingPage />;
  }

  if (user) {
    return <Navigate to={location.state?.from ?? Navigation.home} replace />;
  }

  return <>{children ? children : <Outlet />}</>;
}
